import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/accounts/index.vue') }
}

export class StatsController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/accounts/stats.vue') }
}
